import React, { useEffect, useState, useContext } from "react";
import { Modal, Table } from "react-bootstrap";
import { Context } from "../../../utils/context";

const VendorDesignModal = ({ show, handleClose, vendorId }) => {
  const { getData, IMG_URL } = useContext(Context);

  const [designs, setDesigns] = useState({});

  const getVendorDesigns = async () => {
    if (!vendorId) return;

    const response = await getData(`/admin/vendor/alteration/${vendorId}`);

    if (response?.success) {
      setDesigns(response?.data || {});
    }
  };

  useEffect(() => {
    if (show) {
      getVendorDesigns();
    }
  }, [show, vendorId]);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Vendor Alteration</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {designs?.id ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                {/* <th>Design Name</th> */}
                <th>Alteration Type</th>
                <th>Vendor Design Price</th>
                <th>Express Delivery Price</th>
                <th>Processing Days</th>
                <th>Express Delivery Days</th>
                <th>Express Delivery Time (in hours)</th>
                {/* <th>Processing Type</th> */}
                <th>Vendor Name</th>
                <th>Vendor Contact No</th>
              </tr>
            </thead>

            <tbody>
              {/* {designs?.map((item) => ( */}
              <tr key={designs?.id}>
                {/* Design Name */}
                {/* <td>{designs?.Design?.name || "N/A"}</td> */}

                <td>{designs?.Design?.Alteration_Type?.name || "N/A"}</td>

                <td>₹ {designs?.price || "N/A"}</td>

                <td>₹ {designs?.express_delivery_price || "N/A"}</td>

                <td>{designs?.order_time || "N/A"}</td>
                <td>{designs?.express_delivery_days || "N/A"}</td>
                <td>{designs?.express_delivery_time || "N/A"}</td>

                {/* <td>{designs?.Procesing_Type?.name || "N/A"}</td> */}

                {/* Item Code */}
                {/* <td>{item?.item_code || "N/A"}</td> */}

                {/* Category */}
                {/* <td>{item?.Category?.name || "N/A"}</td> */}

                {/* Sub Category */}
                {/* <td>{item?.Sub_Category?.name || "N/A"}</td> */}

                {/* Occasion */}
                {/* <td>{item?.Occasion?.name || "N/A"}</td> */}

                {/* Description */}
                {/* <td>{item?.description || "N/A"}</td> */}

                {/* Note */}
                {/* <td>{item?.note || "N/A"}</td> */}

                {/* Requirement */}
                {/* <td>{item?.requirement || "N/A"}</td> */}

                {/* Fabrics */}
                {/* <td>
                    {item?.Design_Fabrics?.length > 0 ? (
                      item?.Design_Fabrics?.map((fabric, index) => (
                        <span key={index}>
                          {fabric?.Fabric?.name}
                          {index !== item?.Design_Fabrics?.length - 1
                            ? ", "
                            : ""}
                        </span>
                      ))
                    ) : (
                      <span>N/A</span>
                    )}
                  </td> */}

                {/* Suitable */}
                {/* <td>
                    {item?.Design_Suitables?.length > 0 ? (
                      item?.Design_Suitables?.map((suitable, index) => (
                        <span key={index}>
                          {suitable?.Suitable?.name}
                          {index !== item?.Design_Suitables?.length - 1
                            ? ", "
                            : ""}
                        </span>
                      ))
                    ) : (
                      <span>N/A</span>
                    )}
                  </td> */}

                {/* Vendor Name */}
                <td>{designs?.User?.name || "N/A"}</td>

                {/* Vendor Email */}
                <td>{designs?.User?.contact_no || "N/A"}</td>
              </tr>
              {/* ))} */}
            </tbody>
          </Table>
        ) : (
          <div className="text-center">No Alterations Found</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VendorDesignModal;
